export const tableAdapter = (data) => {
	return data.map((record, index) => {
		return {
			key: index,
			root_pharmacy: record.root_pharmacy,
			link_name: record.link_name,
			editable_name: record.editable_name,
			position: record.position,
			status: record.status,
			_id: record._id,
			country: record.country,
			created_at: record.created_at,
			images: record.images,
			isPageActive: record.isPageActive,
			page: record.page,
			products: record.products,
			tag: record.tag,
			type: record.type,
			updated_at: record.updated_at,
		};
	});
};
